import ScrollContainer from "react-perfect-scrollbar";
import ModalCloseIcon from "~/assets/images/_modal__close.svg";
import { PageTitle } from "~/components/aud/ui/PageTitle";

type NowdoAgainModalProps = {
  onOk: () => unknown;
  onNo: () => unknown;
  title: string;
};

export const NowdoAgainModal: React.FC<NowdoAgainModalProps> = ({ onOk, onNo, title }) => {
  return (
    <div className="_modal__wrapper show">
      <ScrollContainer>
        <div className="_modal wide">
          <div className="content">
            <PageTitle title="Yeah, LEVEL UP!" sub="" />
            <div>{title} の開催、お疲れ様でした！</div>
            <div>
              「継続は力なり」とは成功者たちの言葉です。
              <br />
              やるべきことを後回しにせず、継続してみませんか？
            </div>
            <p>
              <button type="button" className="_button primary medium" onClick={onOk}>
                今すぐ次のクラスルームを予約
              </button>
            </p>
            <div className="_modal__close" onClick={onNo}>
              <ModalCloseIcon />
            </div>
          </div>
        </div>
      </ScrollContainer>
    </div>
  );
};
